import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kissybook",
  "description": "",
  "published": "2007-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/kissybook/swizec/278"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://kissybook.net/"
      }}>{`Kissybook`}</a>{` je zanimiv kolaborativni umetnostni projekt, kateremu sem se danes skusal pridruziti s temle `}<a parentName="p" {...{
        "href": "http://www.deviantart.com/deviation/49689143/"
      }}>{`luskanim zajckom`}</a>{`. Ce bom v koncni rezultat zares vkljucen bom knjigo gotovo kupil, mogoce celo vec kot eno.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      